import { BaseClass } from "ngx-elvis-ds";

export class SAMCommands extends BaseClass {

  static get all(): Array<{ name: string, commands?: string[] }> {
    return [
      {
        name: 'audio',
        commands: [
          'TEXT_TO_SPEECH'
        ]
      },
      {
        name: 'auth',
        commands: [
          'READY_TO_SELL',
          'READY_TO_ADMIN',
          'LOGOFF',
          'SET_SUPERVISOR_MODE',
          'RELOAD_GUI'
        ]
      },
      {
        name: 'xact',
        commands: [
          'XACTINFO',
          'XACTMESSAGES',
        ]
      },
      {
        name: 'cart',
        commands: [
          'GUI_TOTALS',
          'PLU',
          'QUANTITY',
          'DISCOUNT',
          'DISCOUNTS',
          'PRICE',
          'CMD_VARIANT_APPLIED',
          'VOID_PLU',
          'SET_QTY_MODE',
          'SET_QUANTITY'
        ]
      },
      {
        name: 'gui',
        commands: [
          'CMD_GO_TO',
          'SET_FUNC',
          'SET_MSG',
          'SET_LANGUAGE',
          'COMMENT',
          'CLEAN',
          'CLEAN_CUSTOMER',
          'CLEAN_XACT_INFO',
          'CUSTOMER',
          'SET_ROLLING_MESSAGE',
          'sessionlog.update',
          'SCALE_MONITOR',
          'SET_SCALE_STATE',
          'SET_JHIM_PAPERLOW',
          'SET_JHIM_WARNING',
          'loader.open',
          'loader.close',
          'SET_TABLES',
          'SET_TABLE_STATUS',
          'DISPLAY_NOTIFICATION',
          'CLEAR_NOTIFICATIONS',
        ]
      },
      {
        name: 'dialogs',
        commands: [
          'YES_OR_NO',
          'YES_OR_NO_UPDATE',
          'CLOSE_YN_DIALOG',
          'FUNCTION_DIALOG_OPEN',
          'FUNCTION_DIALOG_UPDATE',
          'FUNCTION_DIALOG_CLOSE',
          'INFO_DIALOG_OPEN',
          'INFO_DIALOG_UPDATE',
          'INFO_DIALOG_CLOSE',
          'OVERLAY_DIALOG_OPEN',
          'OVERLAY_DIALOG_UPDATE',
          'OVERLAY_DIALOG_CLOSE',
          'GET_INPUT',
          'GET_INPUT_CLOSE',
          'SEARCH_DIALOG_OPEN',
          'SEARCH_UPDATE',
          'STORE_UPDATE',
          'SEARCH_DIALOG_CLOSE',
          'PAYMENT_DIALOG_OPEN',
          'PAYMENT_DIALOG_UPDATE',
          'PAYMENT_DIALOG_CLOSE',
          'OPEN_KEYBOARD',
          'SET_KBD_OSD',
          'SET_KBD_SETTINGS',
          'CLOSE_KEYBOARD',
          'kbd.open',
          'SET_KBD_OSD',
          'SET_KBD_SETTINGS',
          'PDF_VIEWER_OPEN',
          'PDF_VIEWER_CLOSE',
          'MAINTENANCE',
          'MAINTENANCE_CLOSE',
          'kbd.close',
          'kbd.osd.update',
          'list.dialog.open',
          'list.dialog.update',
          'list.dialog.close',
          'CMD_ITEM_INFO_OPEN'
        ]
      },
      {
        name: 'network',
        commands: [
          'SET_NETWORK_STATUS',
          'SET_JHIM',
          'SET_GLORY_STATUS',
          'CMD_SET_BARSELF_STATUS',
          'POS_UPDATE_AVAILABLE',
        ]
      },
      {
        name: 'menus',
        commands: [
          'SET_MENU'
        ]
      },
    ];
  }
}
